import { render, staticRenderFns } from "./OdontogramCapture.vue?vue&type=template&id=bc8461fa&scoped=true"
import script from "./OdontogramCapture.vue?vue&type=script&lang=js"
export * from "./OdontogramCapture.vue?vue&type=script&lang=js"
import style0 from "./OdontogramCapture.vue?vue&type=style&index=0&id=bc8461fa&prod&scoped=true&lang=css"
import style1 from "./OdontogramCapture.vue?vue&type=style&index=1&id=bc8461fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8461fa",
  null
  
)

export default component.exports